(function () {
  var COOKIE_NAME = 'ma_cookie_consent';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function loadAnalytics() {
    var id = window.maGoogleAnalyticsId;
    if (!id || window.__maGaLoaded) return;
    window.__maGaLoaded = true;
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id);
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', id, { anonymize_ip: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var banner = document.getElementById('cookie-banner');
    var consent = getCookie(COOKIE_NAME);

    if (consent === 'accepted') {
      loadAnalytics();
    } else if (consent === null && banner) {
      banner.hidden = false;
    }

    if (!banner) return;
    var acceptBtn = banner.querySelector('[data-cookie-accept]');
    var declineBtn = banner.querySelector('[data-cookie-decline]');

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        setCookie(COOKIE_NAME, 'accepted', 180);
        banner.hidden = true;
        loadAnalytics();
      });
    }
    if (declineBtn) {
      declineBtn.addEventListener('click', function () {
        setCookie(COOKIE_NAME, 'declined', 180);
        banner.hidden = true;
      });
    }
  });
})();

/* Anti-spam : bloque l'envoi si le champ piège (honeypot) a été rempli par un robot. */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.antispam-field').forEach(function (field) {
      var form = field.closest('form');
      if (!form) return;
      form.addEventListener('submit', function (e) {
        if (field.value) {
          e.preventDefault();
        }
      });
    });
  });
})();
